/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/*-----------------------------------------------------------------------------/
/ Cart conversion changes, 10 Sep 2026, extended 8 Oct 2026
/ 1. Open the cart drawer automatically after a successful Add to Cart.
/ 2. Show a free U.S. shipping progress bar in the cart drawer and on the cart
/    page, kept in step with the cart. The threshold must match the free
/    shipping rate in Settings > Shipping and delivery.
/ 3. Products in SEPARATE_SHIPPING_HANDLES ship on their own rates (Ruth
/    Sweatshirt via Printify), so a cart containing one shows a note instead
/    of the free-shipping progress, and their product page states the real
/    shipping position instead of the sitewide free-shipping line.
/    Printify US rates on 8 Oct 2026 start at USD 7.39 Economy for 0.22 lb,
/    which is one sweatshirt. Update SEPARATE_SHIPPING_FROM if they change.
/ 4. The footer signup offer is corrected from 10% to 15% to match the Klaviyo
/    popup and welcome email. The canonical text lives in the footer section's
/    newsletter_subheading setting in config/settings_data.json; change it there
/    and this override can be deleted.
/-----------------------------------------------------------------------------*/
(function() {
  var IS_AU = document.documentElement.getAttribute('data-ruth-country') === 'AU';
  var FREE_SHIPPING_THRESHOLD = IS_AU ? 5000 : 4000;
  var SEPARATE_SHIPPING_HANDLES = ['ruth-sweatshirt'];
  var SEPARATE_SHIPPING_FROM = '$7.39';
  var SEPARATE_SHIPPING_TEXT = 'Ruth Sweatshirt ships separately from our print partner. U.S. shipping from ' + SEPARATE_SHIPPING_FROM + ', shown at checkout.';
  var SEPARATE_SHIPPING_PDP_TEXT = 'Made to order and shipped by our print partner. U.S. shipping from ' + SEPARATE_SHIPPING_FROM + ', calculated at checkout. Not included in the $40 free shipping offer.';
  var SEPARATE_SHIPPING_DISCLAIMER = 'Taxes calculated at checkout.';
  var FOOTER_SIGNUP_TEXT = 'Get 15% off your first order. Plus new drops, restocks and the occasional sale.';
  var lastCart = null;

  var styles =
    '.free-shipping-bar{margin:0 0 14px;text-align:center}' +
    '.free-shipping-bar__text{margin:0 0 8px;font-size:1.4rem;line-height:1.4}' +
    '.free-shipping-bar__track{height:6px;border-radius:3px;background:rgba(0,0,0,0.1);overflow:hidden}' +
    '.free-shipping-bar__fill{height:100%;width:0;background:#052906;transition:width 0.3s ease}' +
    '.free-shipping-bar[hidden],.free-shipping-bar__track[hidden]{display:none}';

  function formatMoney(cents) {
    return (IS_AU ? 'A$' : '$') + (cents / 100).toFixed(2);
  }

  function hasSeparateShipping(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (SEPARATE_SHIPPING_HANDLES.indexOf(cart.items[i].handle) !== -1) return true;
    }
    return false;
  }

  function updateSeparateShippingProductPage() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match || SEPARATE_SHIPPING_HANDLES.indexOf(match[1]) === -1) return;
    var policies = document.querySelectorAll('.product__policies');
    for (var i = 0; i < policies.length; i++) {
      if (policies[i].getAttribute('data-separate-shipping') === 'done') continue;
      policies[i].textContent = SEPARATE_SHIPPING_PDP_TEXT;
      policies[i].setAttribute('data-separate-shipping', 'done');
    }
  }

  function updateFooterSignupOffer() {
    var notes = document.querySelectorAll('.site-footer__newsletter-subheading p');
    for (var i = 0; i < notes.length; i++) {
      if (notes[i].textContent.indexOf('10% off your first order') === -1) continue;
      notes[i].textContent = FOOTER_SIGNUP_TEXT;
    }
  }

  function ensureBars() {
    if (!document.getElementById('free-shipping-bar-styles')) {
      var style = document.createElement('style');
      style.id = 'free-shipping-bar-styles';
      style.textContent = styles;
      document.head.appendChild(style);
    }
    var inserted = 0;
    var anchors = document.querySelectorAll('.cart-drawer__disclaimer, .cart-policies');
    for (var i = 0; i < anchors.length; i++) {
      var anchor = anchors[i];
      var previous = anchor.previousElementSibling;
      if (previous && previous.hasAttribute('data-free-shipping-bar')) continue;
      var bar = document.createElement('div');
      bar.className = 'free-shipping-bar';
      bar.setAttribute('data-free-shipping-bar', '');
      bar.setAttribute('aria-live', 'polite');
      bar.hidden = true;
      bar.innerHTML =
        '<p class="free-shipping-bar__text" data-free-shipping-text></p>' +
        '<div class="free-shipping-bar__track" data-free-shipping-track><div class="free-shipping-bar__fill" data-free-shipping-fill></div></div>';
      anchor.parentNode.insertBefore(bar, anchor);
      inserted++;
    }
    return inserted;
  }

  function renderBars(cart) {
    lastCart = cart;
    ensureBars();
    var unsupported = IS_AU && cart.items.some(function(item) { return item.handle !== 'ruth-hair-stick'; });
    var separate = hasSeparateShipping(cart);
    var remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
    var percent = Math.min(100, Math.floor(cart.total_price * 100 / FREE_SHIPPING_THRESHOLD));
    var text = unsupported
      ? 'Only the Ruth Hair Stick is available for Australian delivery. Remove other items or switch to United States.'
      : separate
      ? SEPARATE_SHIPPING_TEXT
      : remaining > 0
        ? "You're " + formatMoney(remaining) + (IS_AU ? ' away from free Australian shipping.' : ' away from free U.S. shipping.')
        : (IS_AU ? "You've got free Australian shipping." : "You've got free U.S. shipping.");
    var bars = document.querySelectorAll('[data-free-shipping-bar]');
    for (var i = 0; i < bars.length; i++) {
      var textEl = bars[i].querySelector('[data-free-shipping-text]');
      var track = bars[i].querySelector('[data-free-shipping-track]');
      bars[i].hidden = cart.item_count === 0;
      if (textEl.textContent !== text) textEl.textContent = text;
      if (track.hidden !== (separate || unsupported)) track.hidden = separate || unsupported;
      bars[i].querySelector('[data-free-shipping-fill]').style.width = percent + '%';
    }
    updateDisclaimers(separate && cart.item_count > 0, unsupported);
  }

  function updateDisclaimers(separate, unsupported) {
    var notes = document.querySelectorAll('.cart-drawer__disclaimer, .cart-policies');
    for (var i = 0; i < notes.length; i++) {
      var note = notes[i];
      if (IS_AU) {
        note.textContent = unsupported ? 'Only Hair Sticks can be sent within Australia. Other items in this cart require U.S. delivery.' : 'Australian shipping is A$7, or free on orders of A$50 or more. Sent from Doncaster, Victoria.';
        continue;
      }
      if (!note.hasAttribute('data-original-note')) {
        note.setAttribute('data-original-note', note.innerHTML);
      }
      if (separate) {
        if (note.getAttribute('data-note-state') !== 'separate') {
          note.textContent = SEPARATE_SHIPPING_DISCLAIMER;
          note.setAttribute('data-note-state', 'separate');
        }
      } else if (note.getAttribute('data-note-state') === 'separate') {
        note.innerHTML = note.getAttribute('data-original-note');
        note.removeAttribute('data-note-state');
      }
    }
  }

  function refreshCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(response) { return response.json(); })
      .then(renderBars)
      .catch(function() {});
  }

  function openCartDrawer() {
    if (document.body.classList.contains('template-cart')) return;
    var toggle = document.querySelector('.ajax-cart__toggle');
    if (toggle) toggle.click();
  }

  function watchAddToCartNotifications() {
    var notifications = document.querySelectorAll('[data-cart-notification]');
    for (var i = 0; i < notifications.length; i++) {
      new MutationObserver(function(mutations) {
        for (var j = 0; j < mutations.length; j++) {
          if (mutations[j].target.classList.contains('product__notification--success')) {
            refreshCart();
            openCartDrawer();
            return;
          }
        }
      }).observe(notifications[i], { attributes: true, attributeFilter: ['class'] });
    }
  }

  function watchCartMarkup() {
    var containers = document.querySelectorAll('.cart-drawer, .cart__form');
    for (var i = 0; i < containers.length; i++) {
      new MutationObserver(function() {
        if (ensureBars() > 0 && lastCart) renderBars(lastCart);
      }).observe(containers[i], { childList: true, subtree: true });
    }
  }

  function init() {
    updateSeparateShippingProductPage();
    updateFooterSignupOffer();
    watchAddToCartNotifications();
    watchCartMarkup();
    if (window.jQuery) {
      window.jQuery(document).ajaxComplete(function(event, xhr, settings) {
        if (settings && /\/cart\/(add|change|update|clear)(\.js)?/.test(settings.url || '')) refreshCart();
      });
    }
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
